export enum EOfficialIdentification {
    NO_REQUESTED = 'no_requested',
    ID_DOCUMENT = 'id_document',
    INE = 'ine'
}

export enum EIdentityValidationType {
    ID,
    BIOMETRICS
  }